import React from 'react';
import { FDBodyText, FDPrimaryActionButton, FDStack } from '@facet-wealth/design';
import MetaLayoutRemainingFields from 'Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutRemainingFields';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import PropTypes from 'prop-types';

const EstatePlanStatusLayout = ({ dirty }) => {
  const { onSubmit } = useMetaLayoutContext();
  return (
    <FDStack direction={'column'}>
      <FDBodyText value={'Estate Planning Campaign'} />
      <FDStack direction={'column'} spacing={2}>
        <MetaLayoutRemainingFields />
        <FDPrimaryActionButton size={'sm'} label={'Save'} onClick={onSubmit} disabled={!dirty} />
      </FDStack>
    </FDStack>
  );
};

EstatePlanStatusLayout.defaultProps = {
  dirty: true,
};

EstatePlanStatusLayout.propTypes = {
  dirty: PropTypes.bool,
};

export { EstatePlanStatusLayout };
